export default __webpack_public_path__ + "static/media/player.f768fbe6.png";